<template>
	<div>
		<div class='header'><b>协议记录</b></div>
		<div class="form_top">
			<el-form :model="form" :inline="true" size="mini">
				<el-form-item label="名称：">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAgreementList">查询</el-button>
				</el-form-item>
			</el-form>
			<span>合计：{{table.length}} 份数</span>
		</div>
		<el-table :data='table'>
			<el-table-column  type="index"></el-table-column>
			<el-table-column label="名称" prop="CompanyName"></el-table-column>
			<el-table-column label="签署时间" prop="">
				<template slot-scope='scope'>{{ scope.row.ConsentTime | time }}</template>
			</el-table-column>
			<el-table-column label="操作" prop="">
				<template slot-scope='scope'>
					<el-button type="primary" @click="showFile(scope.row)">查看详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :visible.sync="dialogVisible" >
			<div slot="title">
				<el-button type="primary" v-print="'#agreem'">打印协议</el-button>
			</div>
			<file :name='item.name' :time='item.time'></file>
		</el-dialog>
	</div>
</template>

<script>
	import file from './file.vue';
	export default{
		data() {
			return{
				item:{
					name: "",
					time: ""
				},
				dialogVisible: false,
				table:[],
				form:{
					name:''
				}
			}
		},
		components:{ file },
		filters:{
			time(e){
				var time = new Date(e);
				return time.toLocaleString()
			}
		},
		mounted() {
			this.getAgreementList()
		},
		methods:{
			showFile(e){
				this.item.name = e.CompanyName;
				this.item.time = new Date(e.ConsentTime).toLocaleDateString();
				this.dialogVisible = true;
			},
			async getAgreementList(){
				try{
					let data =`?name=${this.form.name}`
					let res =  await this.$http.getAgreementList(data)
					this.table = res.data
				}catch(e){
					console.log(e);
				}
			},
		},
	}
</script>

<style scoped>
	.header{
		margin-bottom: 20px;
	}
	.form_top{
		display: flex;
		justify-content: space-between;
		margin-left: 30px;
		margin-right: 30px;
	}
</style>